import belt from "../../images/LoPro Belt.jpg";
import chain from "../../images/LoPro Chain.jpg";
import screw from "../../images/LoPro Screw.jpg";
import { configuredClicked } from "../ConfigureClickedFunction";

interface ICompareSideBar {
  compareItemArray: Array<any>;
  handleCheckboxChange: Function;
  handleCheckNone: Function;
  selectedItemsToCompare: Array<any>;
  travelDistance: number;
}

function CompareSideBar(props: ICompareSideBar) {
  const {
    compareItemArray,
    handleCheckNone,
    handleCheckboxChange,
    selectedItemsToCompare,
    travelDistance,
  } = props;

  function openHubSpotChat() {
    const message = {
      type: "OPEN_CHAT",
    };
    window.parent.postMessage(message, window.location.origin);
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="text-left styled-font">MATCHING PRODUCTS</h4>
        <p
          className="m-0"
          onClick={() => handleCheckNone()}
          style={{
            color: "#337ab7",
            fontSize: "12px",
            margin: "0px",
            cursor: "pointer",
          }}
        >
          Uncheck All
        </p>
      </div>
      {compareItemArray && compareItemArray.length ? (
        compareItemArray.map((item, index) => (
          <div
            key={index}
            className="compare-item d-flex margin-bottom"
            style={{
              flexDirection: "column",
              borderBottom: "1px solid lightgray",
            }}
          >
            <a
              href="#"
              className="text-left margin-bottom"
              style={{ fontWeight: "bold" }}
            >
              {item.product}
            </a>
            <div className="d-flex">
              <img
                src={
                  item.drive === "BELT"
                    ? belt
                    : item.drive === "CHAIN"
                    ? chain
                    : item.drive === "LEAD SCREW"
                    ? screw
                    : item.drive === "BALL SCREW"
                    ? screw
                    : ""
                }
                alt={item.name}
                style={{ width: "75px", height: "75px", objectFit: "cover" }}
              />
              <div className="w-100">
                <ul>
                  <li
                    className="text-left"
                    style={{
                      listStyleType: "initial",
                      marginLeft: "2rem",
                      marginBottom: "0px",
                    }}
                  >
                    {item.actuatorText}
                  </li>
                  <li
                    className="text-left"
                    style={{
                      listStyleType: "initial",
                      marginLeft: "2rem",
                      marginBottom: "0px",
                    }}
                  >
                    {item.driveDetails}
                  </li>
                  <li
                    className="text-left"
                    style={{
                      listStyleType: "initial",
                      marginLeft: "2rem",
                      marginBottom: "0px",
                    }}
                  >
                    {item.vendorPN}
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div
                className="d-flex text-left align-items-center"
                style={{ backgroundColor: "#cfd3d4", padding: "5px" }}
              >
                <input
                  type="checkbox"
                  style={{ width: "20px", height: "20px" }}
                  value={item}
                  checked={selectedItemsToCompare?.includes(item)}
                  onChange={() => handleCheckboxChange(item)}
                />
                <p
                  style={{
                    marginBottom: "0px",
                    marginLeft: "5px",
                    fontSize: "15px",
                  }}
                >
                  Add to Compare
                </p>
              </div>
              <button
                type="button"
                onClick={() => configuredClicked(item, travelDistance)}
                className="d-flex text-left align-items-center w-100"
                style={{
                  backgroundColor: "#55565b",
                  padding: "5px",
                  border: "0px",
                  borderRadius: "0px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                }}
              >
                <i className="fas fa-wrench" style={{ color: "white" }}></i>
                <p
                  style={{
                    marginBottom: "0px",
                    color: "white",
                    fontSize: "13px",
                    marginLeft: "5px",
                  }}
                >
                  Configure Without Comparing
                </p>
              </button>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center">
          <i
            className="fas fa-box-open margin-bottom"
            style={{ fontSize: "6rem", color: "lightgray" }}
          ></i>
          <p className="styled-font">No matches yet</p>
          <p>
            Our system will populate this area with products that match your
            requirments.
          </p>
          <p>
          If you need assistance,
          <button
            id="contact-bwc"
            style={{
              background: "none",
              padding: "0px",
              border: "0px",
              fontSize: "18px",
              fontWeight: "400",
              color: "#337ab7",
              boxShadow: "none",
              paddingRight: "5px"
            }}
            type="button"
            onClick={() => openHubSpotChat()}>
              click here
            </button>
            to start a
          conversation with an Application Engineer.
          </p>
        </div>
      )}
    </div>
  );
}

export default CompareSideBar;
